import React from "react";
import { Helmet } from "react-helmet-async";

export function SEO({ title, description, path }) {
    const fullTitle = title
        ? `${title} · Doctor Kichian's Gastroenterology`
        : "Doctor Kichian's Gastroenterology — Expert Digestive Care";
    const desc =
        description ||
        "Comprehensive digestive health services with modern diagnostics, personalized treatment plans, and compassionate, patient-first care.";
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            {path && <link rel="canonical" href={path} />}
        </Helmet>
    );
}
